export default "__VITE_ASSET__mxY2sWyg__"